// extracted by css-extract-rspack-plugin
export default {"subscribePageRoot":"h70gLY"};